export const PLACEHOLDER = "Escribe aquí el motivo del rechazo";
export const SEND = "Enviar";
